export var SENTRY_RELEASE = "e8278787f6ebb45cfaa52f09e75fb583ba4c3a56";
